import { render, staticRenderFns } from "./authGroupItem.vue?vue&type=template&id=5729e596&scoped=true&lang=pug"
import script from "./authGroupItem.vue?vue&type=script&lang=js"
export * from "./authGroupItem.vue?vue&type=script&lang=js"
import style0 from "./authGroupItem.vue?vue&type=style&index=0&id=5729e596&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5729e596",
  null
  
)

export default component.exports